import {
  ADD_NOTIFICATION,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  MARK_NOTIFICATION_AS_SEEN,
} from "../Actions/notificationActions";

const initialState = {
  notifications: [], // ✅ Must be an array
  loading: false,
  error: null,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_NOTIFICATIONS_SUCCESS:
      return { ...state, loading: false, notifications: action.payload };

    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        notifications: [], // <-- make sure we return an array still
      };

    case MARK_NOTIFICATION_AS_SEEN:
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === action.payload ? { ...n, seen: true } : n
        ),
      };

    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications], // Prepend new one
      };

    default:
      return state;
  }
};

export default notificationReducer;
